import React from 'react'
import {Modal} from 'antd'
import BudgetForm from '../../../components/Common/Budgets/BudgetForm'

function AddBudgetModal(props) {
  const {visibleAdd, onCancelAdd, submit, formRef, submitting} = props
  return (
    <Modal
      destoryOnClose={true}
      width={'66%'}
      title={'New Budget'}
      visible={visibleAdd}
      onCancel={onCancelAdd}
      confirmLoading={submitting}
      onOk={submit}
      okText={'Create'}>
      <BudgetForm type={'new'} ref={formRef} {...props} />
    </Modal>
  )
}

AddBudgetModal.propTypes = {}
AddBudgetModal.defaultProps = {}

export default AddBudgetModal
